import { useState } from "react";
import { Bell } from "react-feather";
import { Card, CardBody, Col } from "reactstrap";
import { Alerts, Btn, P } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { DismissingLightAlertTitle } from "../../../../Constants/Constants";
import { DismissAlertSubTitle } from "../../../../Data/UiKits/Alert";

const DismissingLightAlert = () => {
  const [active, setActive] = useState(true);
  return (
    <Col sm="12" xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={DismissingLightAlertTitle} span={DismissAlertSubTitle} />
        <CardBody>
          <Alerts color="light-warning" isOpen={active} className={`alert-dismissible fade`}>
            <Bell />
            <P>{"Hidden content You should check in on some of those fields below."}</P>
            <Btn color="transperant" close onClick={() => setActive(false)} />
          </Alerts>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DismissingLightAlert;
